<template>
	<auth-shell>
		<template v-if="!info">
			<h1 class="auth-title">Set a new password</h1>
			<p class="auth-subtitle">Choose a strong password to secure your Mission Control account.</p>

			<form @submit.prevent="sendResetPasswordLink">
				<div class="auth-field">
					<label class="auth-label" for="password">New password</label>
					<div class="auth-input-group">
						<font-awesome-icon class="auth-input-icon" :icon="['fas', 'lock']" />
						<input
							id="password"
							:type="showPassword ? 'text' : 'password'"
							class="auth-input auth-input--has-toggle"
							placeholder="Enter a new password"
							autocomplete="new-password"
							v-model="password"
							required
						/>
						<button
							type="button"
							class="auth-input-toggle"
							:aria-label="showPassword ? 'Hide password' : 'Show password'"
							@click="showPassword = !showPassword"
						>
							<font-awesome-icon :icon="['fas', showPassword ? 'eye-slash' : 'eye']" />
						</button>
					</div>
				</div>

				<div class="auth-field">
					<label class="auth-label" for="confirmPassword">Confirm password</label>
					<div class="auth-input-group">
						<font-awesome-icon class="auth-input-icon" :icon="['fas', 'lock']" />
						<input
							id="confirmPassword"
							:type="showConfirm ? 'text' : 'password'"
							class="auth-input auth-input--has-toggle"
							placeholder="Re-enter your password"
							autocomplete="new-password"
							v-model="confirmPassword"
							required
						/>
						<button
							type="button"
							class="auth-input-toggle"
							:aria-label="showConfirm ? 'Hide password' : 'Show password'"
							@click="showConfirm = !showConfirm"
						>
							<font-awesome-icon :icon="['fas', showConfirm ? 'eye-slash' : 'eye']" />
						</button>
					</div>
				</div>

				<button v-if="!loading" type="submit" class="auth-btn">
					Reset password
					<font-awesome-icon :icon="['fas', 'arrow-right']" />
				</button>
				<button v-else type="button" class="auth-btn" disabled>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
					Resetting your password…
				</button>
			</form>

			<div class="auth-switch">
				<router-link class="auth-link" to="/login">
					<font-awesome-icon :icon="['fas', 'arrow-left']" /> Back to sign in
				</router-link>
			</div>
		</template>

		<div v-else class="auth-success">
			<div class="auth-success__icon"><font-awesome-icon :icon="['fas', 'check-circle']" /></div>
			<h1 class="auth-title">Password updated</h1>
			<p class="auth-subtitle">You can now sign in with your new password.</p>
			<router-link class="auth-btn" to="/login" style="text-decoration:none">
				Continue to sign in
				<font-awesome-icon :icon="['fas', 'arrow-right']" />
			</router-link>
		</div>
	</auth-shell>
</template>
<script>
import AuthShell from '../../components/auth/AuthShell.vue'
import restApi from '../../api'
import { handleErrors } from '../../actions/helpers'
export default {
	name: 'ResetPassword',
	components: { AuthShell },
	data() {
		return {
			info: '',
			email: '',
			password: '',
			confirmPassword: '',
			passwordToken: '',
			loading: false,
			showPassword: false,
			showConfirm: false,
		}
	},
	created() {
		this.passwordToken = this.$route.query.token
		this.email = this.$route.query.email
	},
	methods: {
		async sendResetPasswordLink() {
			this.loading = true
			restApi
				.post(`/reset-password`, {
					email: this.email,
					password: this.password,
					password_confirmation: this.confirmPassword,
					passwordToken: this.passwordToken,
				})
				.then(
					({ data }) => {
						this.info = data.message
						this.loading = false
					},
					error => {
						this.info = ''
						this.$swal.fire({
							icon: 'error',
							title: handleErrors(error, 'resetPassword'),
							timer: 6000,
						})
						this.loading = false
					}
				)
		},
	},
}
</script>
